export enum VerificationServiceCreateMethodTypes {
    USE_TEMPLATE = "0",
    USE_BLANK = "1",
    USE_IMPORT = "2",
    USE_COPY = "3"
}